import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useFilterValueCounts } from '../useFilterValueCounts'
import { MultiSelectCommandList } from './MultiSelectCommandList'
import type { ValuePickerProps } from './types'
import { useAllLabels } from '@/lib/hooks/useLabels'
import useLoginStore from '@/store/LoginStore'

export function LabelFilterPicker({
  selectedValues,
  onToggleValue,
}: ValuePickerProps) {
  const { t } = useTranslation('tasks')
  const counts = useFilterValueCounts('labels')
  const workspaceId = useLoginStore((state) => state.workspaceId)
  const { labels } = useAllLabels(workspaceId)

  const options = useMemo(
    () =>
      labels.map((l) => ({
        value: l.id,
        label: l.name,
        icon: (
          <span
            className="size-2.5 rounded-full shrink-0"
            style={{ backgroundColor: l.color }}
          />
        ),
      })),
    [labels],
  )

  return (
    <MultiSelectCommandList
      options={options}
      selectedValues={selectedValues}
      onToggle={onToggleValue}
      searchPlaceholder={t('filters.search.labels')}
      counts={counts}
    />
  )
}
